import { render, staticRenderFns } from "./addYouzhicaiProduct.vue?vue&type=template&id=0e6518f3&scoped=true&"
import script from "./addYouzhicaiProduct.vue?vue&type=script&lang=js&"
export * from "./addYouzhicaiProduct.vue?vue&type=script&lang=js&"
import style0 from "./addYouzhicaiProduct.vue?vue&type=style&index=0&id=0e6518f3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6518f3",
  null
  
)

export default component.exports